import { getState } from '~shared/utils/state';

/**
 * Returns the banners_enabled config key to enable/disable
 * displaying the banners component.
 *
 * @returns {Boolean} The flag (defaults to false if site_config key is missing)
 */
export function getBannersEnabled() {
    return getState('banners:enabled');
}

/**
 * Returns the banners Placeholder Id
 *
 * @returns {String} Placeholder Id
 */
export function getBannersPlaceholderId() {
    return getState('banners:placeholderId');
}

/**
 * Returns the jitter value (seconds) for Racing Widgets
 *
 * @returns {Integer} Jitter value (defaults to 0 if the key is missing)
 */
export function getRacingWidgetJitter() {
    return getState('racingwidget:jitter') || 0;
}

/**
 * Returns the heartbeat config
 *
 * @returns {Object} Heartbeat Config
 */
export const getHeartbeatConfig = () => getState('heartbeat');

/**
 * Returns StatsCenter iframe info
 *
 * @returns {Object} StatsCenter iframe object
 */
export const getStatsCenterIframeInfo = () => {
    const statsCentreConfig = getState('statscenter');
    if (!statsCentreConfig || !statsCentreConfig.enabled) {
        return {};
    }

    return statsCentreConfig;
};

/**
 * Returns Sportcaller iframe info
 *
 * @returns {Object} StatsCenter iframe object
 */
export const getSportcallerIframeInfo = () => getState('sportcaller') || {};

/**
 * Returns competition only sport slugs
 *
 * @returns {Array} A list of competition only sport slugs
 */
  export const getCompetitionOnlySlugs = () => getState('competitions_only_sport_slugs') || [];

/**
 * Returns grouping only sport slugs
 *
 * @returns {Array} A list of grouping only sport slugs
 */
    export const getMultiGroupedOnlySlugs = () => getState('grouping_only_sport_slugs') || [];

/**
 * Returns number of markets to open in All markets group
 *
 * @returns {Integer} Number of markets to open in All markets group
 */
export const getNumberOfMarketsInAllMarkets = () => getState('all_markets_group_open_markets') || 0;

/**
 * Returns whether or not the search function is enabled
 *
 * @returns {Boolean} True if enabled, false otherwise
 */
export const getSearchEnabled = () => (getState('search_enabled') === '1') || false;

/**
 * Returns Branded Translations
 *
 * @returns {Array} A list of grouping only sport slugs
 */
 export const getBrandedTranslations = () => getState('brand_translations') || [];

/**
* Returns slugs of sports that don't display selections on inplay homepage
* This can be used with to unusual layouts that are not developed yet but still have an inplay event page
* @returns {Array} A list of grouping only sport slugs
*/
export const getHideInplaySelections = () => getState('hide_inplay_selections') || [];

/**
 * Returns the Geo Check Timeout
 * @return {Integer} Timeout value
 */
export const getGeoCheckTimeout = () => getState('geocheck:timeout');
